import './webcrypto-shim.mjs'
export default window.crypto
